import cx from "classnames";
import Link from "next/link";
import { paginationCalculator } from "pagination-calculator";
import React from "react";

import ArrowIcon from "./assets/arrow.svg?react";

import styles from "./PartTablePagintaion.module.scss";

type PartTablePaginationProps = {
  total: number;
  currentPage: number;
  pageSize: number;
  buildUrl: (nextPage: number) => string;
  className?: string;
};

const PartTablePagination: React.FC<PartTablePaginationProps> = ({
  total,
  currentPage,
  pageSize,
  buildUrl,
  className,
}) => {
  const {
    showingStart,
    showingEnd,
    next: nextPage,
    previous: prevPage,
  } = paginationCalculator({
    total, // total number of items
    current: currentPage, // current page
    pageSize, // number of items per page
  });

  const canGoPrev = prevPage !== false;
  const canGoNext = nextPage !== false;

  return (
    <div className={cx(styles.paginationContainer, className)}>
      <div className={styles.paginationInfo}>
        {showingEnd === 0 ? (
          "No results found"
        ) : (
          <>
            {showingStart.toLocaleString()} - {showingEnd.toLocaleString()} of {total.toLocaleString()} results
          </>
        )}
      </div>
      <Link
        className={cx(styles.paginationArrow, styles.paginationArrowPrev, {
          [styles.active]: canGoPrev,
        })}
        href={canGoPrev ? buildUrl(currentPage - 1) : buildUrl(currentPage)}
        scroll={false}
      >
        <ArrowIcon />
      </Link>
      <Link
        className={cx(styles.paginationArrow, styles.paginationArrowNext, {
          [styles.active]: canGoNext,
        })}
        href={canGoNext ? buildUrl(currentPage + 1) : buildUrl(currentPage)}
        scroll={false}
      >
        <ArrowIcon />
      </Link>
    </div>
  );
};

export default PartTablePagination;
